module.exports = __webpack_public_path__ + "img/18.a93d73ac.jpg";